import React from 'react';
import { ShoppingBag, Heart, Menu } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-border shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center">
            <h1 className="text-2xl md:text-3xl font-serif font-semibold text-gradient">
              Waisted Momma
            </h1>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a href="#about" className="font-sans text-sm font-medium text-foreground hover:text-primary transition-colors">
              ABOUT
            </a>
            <a href="#products" className="font-sans text-sm font-medium text-foreground hover:text-primary transition-colors">
              PRODUCTS
            </a>
            <a href="#testimonials" className="font-sans text-sm font-medium text-foreground hover:text-primary transition-colors">
              REVIEWS
            </a>
            <a href="#faq" className="font-sans text-sm font-medium text-foreground hover:text-primary transition-colors">
              FAQ
            </a>
          </nav>

          {/* Actions */}
          <div className="flex items-center space-x-4">
            <button className="hidden md:block p-2 hover:bg-secondary rounded-full transition-colors" aria-label="Wishlist">
              <Heart className="w-5 h-5 text-foreground" />
            </button>
            <button className="p-2 hover:bg-secondary rounded-full transition-colors" aria-label="Shopping cart">
              <ShoppingBag className="w-5 h-5 text-foreground" />
            </button>
            <button className="md:hidden p-2 hover:bg-secondary rounded-full transition-colors" aria-label="Menu">
              <Menu className="w-5 h-5 text-foreground" />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
